export const IS_AUTHENTICATED = "isAuthenticated";
export const DATE_FORMAT = {
    day:"numeric",
    month:"short",
    year:"numeric"
}
export const ASC = "ASC";
export const DESC = "DESC";
